"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const mini_kit_1 = require("@celo/contractkit/lib/mini-kit");
const wallet_local_1 = require("@celo/wallet-local");
const constants_1 = require("../constants");
const local_storage_1 = require("../utils/local-storage");
const common_1 = require("./common");
class PrivateKeyConnector extends common_1.AbstractConnector {
    constructor(network, privateKey, feeCurrency) {
        super();
        this.network = network;
        this.feeCurrency = feeCurrency;
        this.initialised = false;
        this.type = constants_1.WalletTypes.PrivateKey;
        this.updateFeeCurrency = common_1.updateFeeCurrency.bind(this);
        this.wallet = new wallet_local_1.LocalWallet();
        this.wallet.addAccount(privateKey);
        this.kit = this.newKit(network);
        (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedPrivateKey, privateKey);
    }
    initialise() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initialised)
                return this;
            yield this.updateFeeCurrency(this.feeCurrency);
            this.initialised = true;
            this.emit(common_1.ConnectorEvents.CONNECTED, {
                networkName: this.network.name,
                walletType: this.type,
                walletChainId: null,
                address: this.kit.connection.defaultAccount,
            });
            return this;
        });
    }
    startNetworkChangeFromApp(network) {
        return __awaiter(this, void 0, void 0, function* () {
            this.kit = this.newKit(network);
            yield this.updateFeeCurrency(this.feeCurrency); // new kit so we must set the feeCurrency again
            this.emit(common_1.ConnectorEvents.NETWORK_CHANGED, network.name);
        });
    }
    newKit(network) {
        const kit = (0, mini_kit_1.newKit)(network.rpcUrl, this.wallet);
        kit.connection.defaultAccount = this.wallet.getAccounts()[0];
        return kit;
    }
    supportsFeeCurrency() {
        return true;
    }
    close() {
        (0, local_storage_1.setTypedStorageKey)(constants_1.localStorageKeys.lastUsedPrivateKey, '');
        try {
            this.kit.connection.stop();
        }
        finally {
            this.disconnect();
        }
    }
}
exports.default = PrivateKeyConnector;
//# sourceMappingURL=private-key.js.map